import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Account} from '../../domain/model/account.model';
import {AccountSelectedEvent} from '../../../../../shared/application/events/account/account-selected.event';
import {EVENT_BUS} from '../../../../../shared/domain/tokens/event-bus.token';

@Injectable()
export class AccountSelectorService {
  private readonly eventBus = inject(EVENT_BUS);

  private selected: Account | undefined;
  private last: Account | undefined;

  private selectedAccount$ = new BehaviorSubject<Account | undefined>(undefined);

  getSelected(): Account | undefined {
    return this.selected;
  }

  getSelectedAccount$(): Observable<Account | undefined> {
    return this.selectedAccount$.asObservable();
  }

  getLast(): Account | undefined {
    return this.last;
  }

  setSelected(account: Account | undefined): void {
    this.selected = account;

    if (account) {
      this.last = account;
    }

    this.selectedAccount$.next(this.selected);
    this.notifyChange();
  }

  clear(): void {
    this.selected = undefined;
    this.selectedAccount$.next(undefined);
    this.notifyChange();
  }

  private notifyChange(): void {
    const event = new AccountSelectedEvent(this.selected);

    this.eventBus.publish(event);
  }
}
